module.exports = __webpack_public_path__ + "static/media/ic_upgrade.b729f716.svg";